import { Home } from "modules/general/routes/Home";
import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

export class AppRouter extends React.Component {
  // Render
  public render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
    );
  }
}
